import React, { useState, useEffect } from 'react';
import {
  Command,
  CommandList,
  CommandInput,
  CommandItem,
  CommandGroup
} from "./ui/command";
import { Input } from "./ui/input";
import { Badge } from "./ui/badge";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";
import { X, Check } from "lucide-react";
import { cn } from "../lib/utils";
import { fetchAvailableGenres, fetchAvailableTropes, fetchAvailableTags } from '../services/showService';
import { Genre, Trope, Tag } from '../types/Show';
import styles from "./GenreSelector.module.css";

const TROPES = [
  "Accidental Hero",
  "Accidental Marriage",
  "Accidental Pregnancy",
  "Alien Invasion",
  "Amateur Sleuth",
  "Amnesia",
  "Ancient Mysteries",
  "Anthropomorphic Animals",
  "Anti-Hero",
  "Apocalypse",
  "Arranged Marriage",
  "Bad Boy",
  "Betrayal",
  "Billionaire",
  "Blackmail",
  "Body Swap",
  "Bodyguard",
  "Bodyguard Romance",
  "Boss-Employee Relationship",
  "Boy Love",
  "Bromance",
  "Buddy Cop",
  "Cape and Cowl",
  "Celebrity Couple",
  "Celebrity Relationship",
  "Celebrity Romance",
  "Cheating",
  "Chosen One",
  "Cinderella Story",
  "Cliffhanger",
  "Coming of Age",
  "Conspiracy",
  "Contemporary",
  "Contract Marriage",
  "Corporate thriller",
  "Cosmic War",
  "Cowboy Hero",
  "Criminal consultants",
  "Culinary Arts",
  "Cultural Folklore",
  "Cursed Objects",
  "Damsel in Distress",
  "Dark Forces",
  "Dark Secret",
  "Dark Secrets",
  "Deadly Game",
  "Death Game",
  "Detective Fiction",
  "Divine Betrayal",
  "Double Life",
  "Dreamscape Exploration",
  "Dystopia",
  "Emotional Infidelity",
  "Enemies to Lovers",
  "Environmental Horror",
  "Epic Quest",
  "Evil",
  "Extramarital Affair",
  "Fairy Tale Retelling",
  "Fake Dating",
  "Fake Relationship",
  "Family Secrets",
  "Fatal Attraction",
  "Fated Love",
  "Fated Mates",
  "Fish Out of Water",
  "Forbidden Love",
  "Forbidden Romance",
  "Forced Marriage",
  "Forced Proximity",
  "Forensic",
  "Found Family",
  "Framed for Murder",
  "Framing for murder",
  "Friends to Lovers",
  "Frivolous Ruler",
  "Futuristic",
  "Game",
  "Gang Rivalry",
  "Ghostly Apparitions",
  "Ghosts",
  "Good vs. Evil",
  "Grump And Sunshine",
  "Haunted Cityscape",
  "Haunted Heritage",
  "Haunted Locale",
  "Haunted Town",
  "Heirloom",
  "Heist",
  "Hero's Journey",
  "Hidden Feelings",
  "Hidden Identity",
  "Hidden Marriage",
  "Hidden Past",
  "Hidden Powers",
  "High School Drama",
  "Historical Romance",
  "Horror",
  "Immortality",
  "Indigenous Mythology",
  "Intelligent Psychopath",
  "Investigation",
  "Isolated Locales",
  "Legacy",
  "Lesbian Couple",
  "LGBTQ",
  "Lost Powers",
  "Lost World",
  "Love At First Sight",
  "Love Triangle",
  "Loveless Marriage",
  "Low Fantasy",
  "Magical Artifacts",
  "Magical Beasts",
  "Magical Realism",
  "Magical Realm",
  "Magical School",
  "Magical Society",
  "Magical Training",
  "Marriage",
  "Marriage in Trouble",
  "Marriage of Convenience",
  "Martial Arts",
  "Medical Drama",
  "Mentor",
  "Misjudged Death",
  "Mistaken Identity",
  "Misunderstandings",
  "Monster Hunter",
  "Monsters",
  "Multiple Murders",
  "Murder Investigation",
  "Murder Mystery",
  "Mysterious Relics",
  "Mythical Creatures",
  "Novice to Expert",
  "Office Romance",
  "One Night Stand",
  "Opposites Attract",
  "Orphan's Plot Trinket",
  "Overpowered Protagonist",
  "Parallel Universe",
  "Paranormal",
  "Paranormal Investigation",
  "Paranormal Romance",
  "Post-Apocalyptic Survival",
  "Power Games",
  "Power Struggle",
  "Powerful Antagonist",
  "Powerful Protagonist",
  "Private Detective",
  "Procedural",
  "Prophesied Hero",
  "Psychological Romance",
  "Psychological Thriller",
  "Quest",
  "Quest for Identity",
  "Race Against Time",
  "Rags to Riches",
  "Rebellion",
  "Redemption Arc",
  "Rekindled Love",
  "Reluctant Hero",
  "Reluctant Investigator",
  "Reluctant Protagonist",
  "Reluctant Sleuth",
  "Reluctant Lovers",
  "Revenge",
  "Reverse Harem",
  "Rich Guy/Poor Girl",
  "Rivalry",
  "Robot/Human Romance",
  "Rogue AI",
  "Role Reversal",
  "Roommate Romance",
  "Sacrifice",
  "Satire",
  "School of Hard Knocks",
  "Second Chance",
  "Second Chance at Love",
  "Secret Child",
  "Secret Heirs",
  "Secret Identity",
  "Secret Organization",
  "Secret Past",
  "Secret wealth",
  "Secrets",
  "Self-Discovery",
  "Single Parent",
  "Slice of Life",
  "Slow Burn",
  "Soulmates",
  "Space Opera",
  "Star-Crossed Lovers",
  "Strangers to Lovers",
  "Stuck Together",
  "Superhero",
  "Supernatural",
  "Supernatural Mentor",
  "Superpowers",
  "Surrogacy",
  "Survival",
  "Survivalism",
  "Swords and Sorcery",
  "System",
  "Teenage",
  "The Big Race",
  "The Chosen One",
  "The Farm Boy",
  "Thriller",
  "Time Loop",
  "Time Skip",
  "Time Travel",
  "Traditional Rituals",
  "Tragic Past",
  "Transmigration",
  "Traveling Protagonist",
  "Twist Ending",
  "Underdog",
  "Underdog Story",
  "Unexpected Love",
  "Unexpected Parenthood",
  "Unlikely Friendship",
  "Unlikely Hero",
  "Unreliable Narrator",
  "Unrequited Love",
  "Unresolved Tension",
  "Urban Horror",
  "Vampire/Werewolf Love Triangle",
  "Victim Gets Revenge",
  "Villain Protagonist",
  "Villain with a Heart of Gold",
  "War Epic",
  "Weak to Strong",
  "Werewolf",
  "Whodunit",
  "Witchcraft",
  "Workplace Drama",
  "Workplace Romance",
  "World War",
  "Young Adult",
  "Young Love",
  "Zero to Hero",
  "Zombie Outbreak"
];

interface GenreSelectorProps {
  selectedGenres: string[];
  onChange?: (selected: string[]) => void;
  error?: boolean;
  maxItems?: number;
  placeholder?: string;
  type?: 'genres' | 'tropes' | 'tags'; // Add type prop to determine what to fetch
}

export const GenreSelector: React.FC<GenreSelectorProps> = ({
  selectedGenres,
  onChange,
  error,
  maxItems = 3,
  placeholder,
  type = 'tropes' // Default to tropes for backward compatibility
}) => {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [options, setOptions] = useState<string[]>(TROPES); // Initialize with fallback
  const [loading, setLoading] = useState(false);

  // Fetch options based on type
  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        let response: Genre[] | Trope[] | Tag[] | null = null;

        switch (type) {
          case 'genres':
            response = await fetchAvailableGenres();
            break;
          case 'tropes':
            response = await fetchAvailableTropes();
            break;
          case 'tags':
            response = await fetchAvailableTags();
            break;
          default:
            response = null;
        }

        if (response && Array.isArray(response)) {
          const optionNames = response.map(item => item.name);
          setOptions(optionNames);
        } else {
          // Fallback to hardcoded TROPES if API fails
          console.warn(`Failed to fetch ${type}, using fallback`);
          if (type === 'tropes') {
            setOptions(TROPES);
          } else {
            // For genres/tags, use empty array and show error
            setOptions([]);
          }
        }
      } catch (error) {
        console.error(`Error fetching ${type}:`, error);
        // Fallback to hardcoded TROPES for tropes, empty for others
        setOptions(type === 'tropes' ? TROPES : []);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, [type]);

  const filteredGenres = options.filter((genre) =>
    genre.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSelectGenre = (genre: string) => {
    if (selectedGenres.includes(genre) || (maxItems && selectedGenres.length >= maxItems)) return;
    const newSelected = [...selectedGenres, genre];
    onChange?.(newSelected);
    setSearchQuery("");
  };

  const handleRemoveGenre = (genre: string) => {
    const newSelected = selectedGenres.filter((g) => g !== genre);
    onChange?.(newSelected);
  };

  return (
    <div className={styles.genreSelectorWrapper}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <div 
            className={cn(
              styles.inputWrapper,
              error && "border-destructive",
              "focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2"
            )}
          >
            {selectedGenres.map((genre) => (
              <Badge key={genre} className={styles.genreChip}>
                {genre}
                <X
                  className={styles.removeIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveGenre(genre);
                  }}
                />
              </Badge>
            ))}
            <input
              placeholder={selectedGenres.length >= (maxItems || Infinity)
                ? "Maximum items selected"
                : placeholder || `Search and select up to ${maxItems} items`}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={() => setOpen(true)}
              className={styles.genreInput}
              disabled={Boolean(maxItems && selectedGenres.length >= maxItems)}
            />
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-[var(--radix-popover-trigger-width)] p-0" align="start">
          <Command shouldFilter={false}>
            <CommandInput
              placeholder="Search genres..."
              value={searchQuery}
              onValueChange={setSearchQuery}
              className="border-none focus:ring-0"
            />
            <CommandList>
              <CommandGroup>
                {filteredGenres.map((genre) => (
                  <CommandItem
                    key={genre}
                    onSelect={() => handleSelectGenre(genre)}
                    disabled={Boolean(maxItems && selectedGenres.length >= maxItems && !selectedGenres.includes(genre))}
                  >
                    <span>{genre}</span>
                    <Check
                      className={cn(
                        "ml-2 h-4 w-4",
                        selectedGenres.includes(genre) ? "opacity-100" : "opacity-0"
                      )}
                    />
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Popover>
    </div>
  );
};